export const FollowersOptions = [
  {
    id: 'less_than_15k',
    name: 'txt_less_than_150k',
  },
  {
    id: '15k_100k',
    name: 'txt_150k_1m',
  },
  {
    id: '100K_1M',
    name: 'txt_1M_5M',
  },
  {
    id: 'more_than_1M',
    name: 'txt_more_that_5m',
  },
];
